import object from './request'

const service = object.service; // 带token
const login = object.loginService; // 不带token
const authCodeLoginService = object.authCodeLoginService;
const pmAppVersion='8.6.2'
 

const server = {
	// 登录
	login: {
		// app密码登录
		appLoginByPwd: function (data) {
			return login.post('/auth/douniuapp', data)
		},
		// pc密码登录
		loginByPwd: function (data) {
			return login.post('/auth/douniuapp/pc', data)
		},
		// 用户注册/登录
		registAndLogin: function (data) {
			return login.post('/auth/registerAndLogin', data)
		},
		// App注册
		appRegist: function (data) {
			return login.post('auth/registerUser', data)
		},
		// 游客登录
		customerLogin: function (data) {
			return login.post('/auth/tourist', data)
		},
		// 获取验证码
		getMessage: function (data) {
			return login.post('/douniuapp/smscode', data)
		},
		//获取验证码
		getSmsCode: function(data) {
			return login.post('/douniuapp/unsign/smscode',data);
		},
		// 手机验证码登录
		loginByMessage: function (data) {
			return login.post('/auth/douniuphone', data)
		},
		// 忘记密码
		forgetPwd: function (data) {
			return login.post('/auth/forgetPwd', data)
		},
		//手机验证码验证
		phoneCodeCheck: function (data) {
			return login.post('/douniuapp/smscode/check', data)
		},
		// 账号注册
		register: function (data) {
			return login.post('/auth/registerUser', data)
		},
		// 获取用户协议
		getRegPro: function () {
			return login.get('/auth/getRegPro')
		},
		//获取文字验证码/douniuapp/c/smscode
		getCheckImgCode(data){
			return login.post('/unauth/identityCode/getImgCode', data)
		},
		checkImgCode(data){
			return login.post('/unauth/identityCode/checkImgCode', data)
		},
		// 获取验证码
		getMessageByCheck: function (data) {
			return login.post('/douniuapp/unsign/c/smscode', data)
		},
		// 登出
		logout: function (data) {
			return login.post('/auth/douniuapp/logout', data)
		},
  },
  //微信公众号授权
  auth:{
    // 授权码
    authCode: function (data) {
      return authCodeLoginService.post('/auth/code', data,{
        headers:{ 'Content-Type': 'application/x-www-form-urlencoded'}
      })
    },
    authUserInfo: function (data) {
      return authCodeLoginService.post('/unauth/authUserInfo', data,{
        headers:{ 'Content-Type': 'application/x-www-form-urlencoded'}
      })
    },
  },
  // 基础
  base: {
    // 获取授权
    getCode: function (data) {
      return service.post('/wx/code', data)
    },
    // 获取ticket
    getTicket: function (data) {
      return service.post('/page/getTicket/'+ data)
    },
  },
  // 我的
  mine: {
    // 查询数据
    getData: function () {
      return service.post('/douniu/userCenter')
    },
    // 签到
    sign: function () {
      return service.post('/douniu/sign')
    },
    // 今日积分明细
    getTodayScore: function (data) {
      return service.post('/douniu/userTodayScore', data)
    },
    // 历史积分明细
    getHistoryScore: function (data) {
      return service.post('/douniu/userScore', data)
    },
    // 牛币明细
    getCoin: function (data) {
      return service.post('/douniu/userCoin', data)
    },
    // 修改密码
    changePwd: function (data) {
      return service.post('/douniu/editPwd', data)
    },
    // 客服热线
    getPhone: function () {
      return service.post('/phone/hotline')
    },
	
	//获取二要素验证文案
	getIdentityCheckTip: function(data) {
		return service.post('/userinfo/attestationId/tip',data);
	},
	//二要素验证（身份验证）
	identityCheck: function(data) {
		return service.post('/userinfo/attestationId',data);
	},
	//身份验证结果
	getIdentityCheckRes: function(data) {
		return service.post('/douniu/personalInfoVerify',data);
	},
	
	//我的订阅
	getSubscribe: function(data) {
		return service.post('/oapi/v1/web/content/getMyLiveVideoList',data);
	},
	
	//我的订阅（牛人课）
	getBullClassSubscribe: function(data) {
		return service.post('/app/course/subscribe',data);
	},
	//我的订阅（App商城支付）
	getSearchSubscribe: function(data){
		return service.post('/app/mall/pay/search/subscribe',data);
	},
  },
  // 我的钱包
  wallet: {
    // 在线充值列表
    getRechargeList: function (data) {
      return service.post('/app/recharge/getinfo',data)
    },
    // 校验充值卡
    checkGoldCard: function (data) {
      return service.post('/douniu/recharge/web/checkGoldCard', data)
    },
    // 充值卡确认充值
    cardConfirmRecharge: function (data) {
      return service.post('/douniu/recharge/web/cardConfirmRecharge', data)
    },
  },
  // 支付
  payment: {
	//+---------------------------充值---------------------
	//获取支付信息
	payInfo: function(data) {
		return service.post('/oapi/v1/web/charge/info', data);
	},
	//创建充值订单
	createOrder: function(data) {
		return service.post('/oapi/v1/web/charge/create/order',data);
	},
	//确认充值订单
	confirmRechargePay: function(payChannel,data) {
		return service.post('/oapi/v1/web/charge/confirm/pay/' + payChannel,data);
	},
	//检查充值状态
	checkPayStatus: function(data) {
		return service.get('/oapi/v1/web/charge/check/status/' + data.orderId,data);
	},
	
	//+-----------------------------支付---------------------
	//支付信息web
	payInfoByWeb: function(data){
		return service.post('/oapi/v1/web/pay/payInfo',data);
	},
	//app支付信息获取
	payInfoByApp: function(data){
		return service.post('/douniu/payInfo',data);
	},
	//小程序支付信息获取
	payInfoByApplet: function(data){
		return service.post('/oapi/v1/applet/pay/payInfo',data);
	},
	//h5支付信息获取
	payInfoByH5: function(data){
		return service.post('/oapi/v1/h5/pay/payInfo',data);
	},
	
	//创建支付订单
	createPayOrder: function(data) {
		return service.post('/pay/order',data);
	},
	//确认订单提交
	confirmBuyPay: function(data) {
		return service.post('/pay/buy',data);
	},
	//检查支付状态
	checkBuyPayStatus:function(data){
		return service.get('/oapi/v1/web/pay/checkpay/' + data.orderId,data);
	},
	
	//检查支付
	confirmPay: function(data) {
		return service.post('/oapi/v1/web/confirm/pay',data);
	},
	//检查购买
	confirmPayBuy: function(data) {
		return service.post('/oapi/v1/web/pay/buy',data);
	},
	
	
	
    // 支付界面
    payment: function () {
      return service.post('/douniu/recharge/payRelative')
    },
    
    // 获取订单 
    getOrder: function (data,apiType) {
      var apiUrl='/oapi/v1/h5/pay/order'
      if(apiType || applet_to_h5){
        var apiUrl='/oapi/v1/applet/pay/order'
      }
      return service.post(apiUrl,data+'&pmAppVersion=8.6.2')
    },
    // 通过订单购买 
    payByOrder: function (data,apiType) { 
      var apiUrl='/oapi/v1/h5/pay/buy'
      if(apiType || applet_to_h5){
        var apiUrl='/oapi/v1/applet/pay/buy'
      }
      return service.post(apiUrl,data+'&pmAppVersion=8.6.2')
    },
    // 判断是否支付成功 
    checkpay: function (data,apiType) {
      var apiUrl='/oapi/v1/h5/pay/checkpay'
      if(apiType || applet_to_h5){
        var apiUrl='/oapi/v1/applet/pay/checkpay'
      }
      return service.post(apiUrl,data+'&pmAppVersion=8.6.2')
    },
    // 获取充值订单 
    getRechargeOrder: function (data) {
      return service.post('/app/recharge/create/order', data)
    },
    // android通过订单充值 
    payByRechargeOrder: function (data) {
      return service.post('/app/recharge/android/notify', data)
    },
    // 检查订单是否支付成功---充值 
    checkRechargepay: function (data) {
      return service.get('/app/recharge/page/checkrecharge/'+ data)
    },
  },
  // 牛视点
  NiuCeLue: {
    // 获取牛视点列表数据
    getData: function (data) {
      return service.post(getPath() + '/content/articleList', data)
    },
    // 获取详情页
    getDetail: function (data) {
      return service.post(getPath() + '/content/articleInfo', data)
    },
  },
  // 牛人课
  NiuRenKe: {
    // 获取牛人课列表数据
    getData: function (data) {
      return service.post(getPath() + '/content/videoList', data)
    },
    // 获取详情页
    getDetail: function (data) {
      return service.post(getPath() + '/content/videoInfo', data)
    },
    // 牛人课内容详情
    getDetailInfo: function (data) {
      return service.post(getPath() + '/content/videoContentInfo', data)
    },
    // 换一换
    changePage: function (data) {
      return service.post(getPath() + '/content/relative', data)
    },
  },
  // 斗牛TV
  douniuTV: {
    // 获取斗牛TV列表数据
    getData: function () {
      return service.post(getPath() + '/content/tvList')
    },
    // 加载更多斗牛TV列表数据
    getMore: function (data) {
      return service.post(getPath() + '/content/getMoreRepeat', data)
    },
    // 获取直播详情页
    getDetail: function (data) {
      return service.post(getPath() + '/content/liveRoomInfo', data)
    },
    // 获取回放详情页
    getRepeatDetail: function (data) {
      return service.post(getPath() + '/content/getRepeatInfo', data)
    },
  },
  // 金股池
  jgc: {
    // app金股池列表
    getData(data) {
      return service.post('/app/jgcList',data)
    },
    // app金股池详情
    getDetail(data) {
      return service.post('/app/jgcDetail',data)
    },
    // app金股池详情
    latestSell(data) {
      return service.post('/app/latestSell',data)
    },
  },
  
  
  
  //直播
  live: {
	  //web首页查询直播预告, 热门课程, 斗牛策略列表
	  getfirstContentList(data) {
			return service.post('/oapi/v1/web/home/getfirstContentList', data)
	  },
	  //直播推荐位列表
	  getRecommentList(data) {
		  return service.post('/oapi/v1/web/live/liveRecommendList', data)
	  },
	  //直播列表
	  getList(data) {
		  return service.post('/oapi/v1/web/live/liveList', data)
	  },
	  //直播详情
	  getDetail(data) {
	  	  return service.post('/oapi/v1/web/live/liveDetail', data)
	  },
	  
	  //直播列表
	  getListByApp(data) {
	  	return service.post('/app/live/liveList', data)
	  },
	  
	  
	  //小程序直播详情
	  getDetailByApplet(data) {
		  return service.post('/oapi/v1/applet/live/liveDetail',data);
	  },
	  //录播列表
	  getPlaybackList(data) {
	  	  return service.post('/oapi/v1/web/live/getLiveRepeatList', data)
	  },
	  //录播列表
	  getPlaybackListByApplet(data) {
	  	  return service.post('/oapi/v1/applet/live/getLiveRepeatList', data)
	  },
	  //录播详情
	  getPlaybackDetail(data) {
	  	  return service.post('/oapi/v1/web/live/detailLiveRepeat', data)
	  },
	  //房间状态
	  checkLive(data) {
		  return service.post('/oapi/v1/web/live/checkLive', data)
	  },
	  //下载pdf
	  downloadPdf(data) {
	  	 return service.post('/oapi/v1/web/live/downloadPdf', data)
	  },
	  //验证直播间密码
	  checkLivePwd(data) {
	  	 return service.post('/oapi/v1/web/live/livePwd', data)
	  },
	  //发送弹幕
	  sendBulletChat(data) {
	  	 return service.post('/oapi/v1/web/live/sendDanmu', data)
	  },
	  //获取礼物列表
	  getGiftList(data) {
	  	 return service.post('/oapi/v1/web/live/getgiftHf', data)
	  },
	  //直播礼物贡献榜
	  getGiftRank(data) {
	  	 return service.post('/oapi/v1/web/live/getRankMf', data)
	  },
	  //更新试看时间
	  updateLookTime(data){
		return service.post('/app/live/update/duration',data);
	  },
	  //回传直播在线用户
	  updateLiveOnline(data){
	  	return service.post('/app/live/lottery/liveOnLineUserMonitor',data);
	  },
  },
  // pc牛策略
  bullStrategy: {
	  //牛策略列表
	  getList(data) {
		  return service.post('/oapi/v1/web/home/getNclContentList', data)
	  },
	  //牛策略列表
	  getListByApplet(data) {
		return service.post('/unauth/applet/v2/getNclContentList', data)
	  },
	  //牛策略详情
	  getDetail(data) {
		  return service.post('/oapi/v1/applet/newsDetail', data)
	  },
	  //牛观点详情
	  getViewDetail(data) {
		  return service.get('/unauth/applet/v2/viewPoint/detail', data)
	  },
	  //牛观点详情
	  getViewDetailByAuth(data) {
		  return service.post('/oapi/v1/applet/viewPoint/detail', data)
	  },
	  
	  //看头条列表
	  HeadlinesList(data){
		  return service.post('/zixun/zixunlist', data)
	  },
	  //看头条详情
	  HeadlinesDetail(data){
		  return service.post('/zixun/zixuninfo', data)
	  },
	  //看头条点赞
	  HeadlinesLike(data) {
		return service.post('/zixun/like', data)
	  },
	  //看头条评论
	  HeadlinesComment(data) {
		  return service.post('/zixun/comment', data)
	  }
  },
  //牛人课
  bullClass: {
		//web牛人课列表
		getListByWeb(data) {
		  return service.post('/oapi/v1/web/course/videoAllList', data)
		},
		//web牛人课详情
		getDetailByWeb(data) {
		  return service.post('/oapi/v1/web/course/videoInfo', data)
		},
		//web牛人课详情推荐
		getDetailRecommendByWeb(data) {
		  return service.post('/oapi/v1/web/course/hot', data)
		},
		
		
		
	  //app牛人课列表
	  getListByApp(data) {
		  return service.post('/app/course/videoAllList', data)
	  },
	  //app牛人课详情
	  getDetailByApp(data) {
	  	 return service.post('/app/course/videoInfo',data)
	  },
	  //小程序牛人课列表
	  getListByAppletAuth(data) {
		  return service.post('/oapi/v1/applet/videoAllList', data)
	  },
	  //小程序牛人课列表
	  getListByApplet(data) {
		  return service.post('/unauth/applet/v2/videoAllList', data)
	  },
	  //小程序牛人课详情
	  getDetailByAppletAuth(data) {
		  return service.post('/oapi/v1/applet/videoInfo', data)
	  },
	  //小程序牛人课详情
	  getDetailByApplet(data) {
		 return service.post('/unauth/applet/v2/videoInfo', data)
	  },
  },
  
  
  
  
  
  //+---------------------小程序使用的相关接口---------------------------
  // applet: {
	 // protocl: "https://api.douniu8.com/page/applet/protocl",
	     // //提交code
	     // checkUser: apiHost + "/unauth/applet/checkUser",
	     // //登陆接口
	     // wxLogin: apiHost + "/unauth/applet/oneClickLogin",
	     // //校验授权
	     // checkAuthorize: apiHost + "/unauth/applet/checkAuthorize",
	     // //提交授权
	     // addAuthorize: apiHost + "/unauth/applet/addAuthorize",
	     // //我的邀请码
	     // getInviteCode: apiHost + "/unauth/applet/v2/getInviteCode",
	     // //首页轮播图和图标列表
	     // getfirstBannerAndIcon: apiHost + "/unauth/applet/v2/getfirstBannerAndIcon",
	     // //首页 查询小程序首页直播预告, 热门课程, 斗牛策略列表
	     // getfirstContentList: apiHost + "/unauth/applet/v2/getfirstContentList",
	     // //小程序斗牛策略关注/推荐/投资大咖列表  
	     // getNclContentList: apiHost + "/unauth/applet/v2/getNclContentList",
	     // //获取验证码
	     // verificationCode: apiHost + "/unauth/applet/sendSmsCode",
	     // //手机号验证码登陆
	     // phoneLogin: apiHost + "/unauth/applet/phoneLogin",
	     // //获取文件上传签名
	     // sigurature: apiHost + "/web/upload/sigurature",
	     // //我的关注 首席列表 信息列表
	     // myInterest: apiHost + "/usersubcription/usersublist",
	     // //我的关注取消关注
	     // unfollow: apiHost + "/usersubcription/usersub",
	     // //关注跳转首席信息
	     // sxInfo: apiHost + "/studioInfo/sxInfo",
	     // //关注跳转首席信息分析师我的策略接口
	     // Ncllist: apiHost + "/unauth/applet/v2/analyst/Ncllist ",
	     // //我的关注牛人课列表
	     // videoAllList: apiHost + "/app/course/videoAllList",
	     // //我的直播列表
	     // mylives: apiHost + "/unauth/applet/v2/getMyLiveVideoList",
	     // //上传身份证
	     // UploadIDCard: apiHost + "/userinfo/attestationId",
	     // //获取二要素验证中的文案
	     // Copywriter: apiHost + "/userinfo/attestationId/tip",
	     // //身份验证是否成功
	     // personalInfoVerify: apiHost + "/douniu/personalInfoVerify",
	     // //我的斗牛学院
	     // MyCourse: apiHost + "/app/course/appMyCourse",
	     // //获取风险评估等级结果 测试题选项
	     // AccessOptions: apiHost + "/risk/risktest",
	     // //获取风险结果等级
	     // getscore: apiHost + "/risk/getscore",
	     // //提交风险评估
	     // submitOptions: apiHost + "/risk/riskscore",
	     // //用户协议列表
	     // userAgreement: apiHost + "/protocol/userProtocol ",
	     // //获取直播列表
	     // liveList: apiHost + "/app/live/liveList",
	     // //获取文件地址
	     // getImageUrl: apiHost + "/web/upload/getUrl",
	     // //保存牛观点
	     // savePoint: apiHost + "/unauth/applet/v2/viewPoint/save",
	     // //获取直播详情接口
	     // liveDetail: apiHost + "/app/live/liveDetail",
	     // //直播试看更新时间
	     // duration: apiHost + "/app/live/update/duration",
	     // //牛学院列表滑动
	     // videoModelList: apiHost + "/unauth/applet/v2/videoModelList",
	     // //获取直播间回放列表
	     // getLiveRepeatList: apiHost + "/app/live/getLiveRepeatList",
	     // //牛学院课列表
	     // videoInfo: apiHost + "/app/course/videoInfo",
	     // //学院转发
	     // vifeoshare: apiHost + "/unauth/applet/v2/share",
	     // //牛学院列表
	     // zixuninfo: apiHost + "/unauth/applet/v2/newsDetail",
	     // //斗牛学院订阅
	     // getAppletBuyNum: apiHost + "/unauth/applet/v2/getAppletBuyNum",
	     // //观点详情
	     // viewPointDetail: apiHost + "/unauth/applet/v2/viewPoint/detail",
	     // //关注老师
	     // usersubcriptionUsersub: apiHost + "/usersubcription/usersub",
	     // //文章点赞
	     // zixunlike: apiHost + "/zixun/like",
	     // //观点点赞
	     // pointdz: apiHost + "/unauth/applet/v2/save/dz",
	     // //插入评论
	     // saveComment: apiHost + "/unauth/applet/v2/saveComment",
	     // //查询评论
	     // selectComments: apiHost + "/unauth/applet/v2/comments",
	     // //点赞
	     // likeSave : apiHost + "/unauth/applet/v2/like/save",
	     // //获得评论的所有回复
	     // getCommentReply: apiHost + "/unauth/applet/v2/getCommentReply",
	     // //验证直播间密码
	     // password: apiHost + "/app/live/livePwd",
	     // //退出接口
	     // logOut:apiHost+"/auth/douniuapp/logout",
	     // //关注跳转首席斗牛直播
	     // sxlive: apiHost+"/sxlive/list",
	     // //获取游客token
	     // temptoken:apiHost+"/auth/tourist",
	     // //发送弹幕
	     // sendDanmu: apiHost + "/app/live/sendDanmu",
	     // //推荐位列表
	     // liveRecommendList: apiHost + "/app/live/liveRecommendList",
  // }
}

// 通过域名返回对应接口路径
function getPath() {
  if (window.location.host.split('.')[0] == 'localhost:8080' || window.location.host.split('.')[0] == 'localhost:8081' || window.location.host.split('.')[0] == '192') {
    return '/songyan'
  } else {
    return '/' + window.location.host.split('.')[0];
  }
}

export default server



// WEBPACK FOOTER //
// ./src/utils/api.js